/* eslint react/jsx-no-bind:0 */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import moment from 'moment';
import { Row,Col,Table,Button } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { PropTypes } from "prop-types"
import { blue,warning } from '../../../utils/constants';
import ContentWrapper from "../../../components/layout/ContentWrapper";

const formName = 'postevent'

class SearchResults extends Component {

  constructor(props)
  {
	super(props)
	this.handleViewEventDetails = this.handleViewEventDetails.bind(this)
}

handleViewEventDetails(eventId) {
	this.props.onViewEventDetails(eventId);
}

render() {
	const {
		searchResults, 
	} = this.props;

	const recordsFound = (searchResults !== undefined) && (searchResults.length > 0)

	if (recordsFound === false) {
		return (<span style={{ color:warning }}>
							<i className='fa fa-info-circle' />&nbsp;&nbsp;No events found
						</span>)
	}	
	return (
	<ContentWrapper>
	<Dialog ref={(el) => {this.dialog = el}} />
	<Row form={formName}>
    <Col sm={11}>
		<Table striped>
			<thead>
				<tr>
					<th width='150px'>Season</th> 
					<th width='150px'>Event Name</th>  
					<th width='180px'>Director</th>                    
					<th width='180px'>Start Date</th>
					<th width='180px'>End Date</th>
					<th width='180px'>Status</th>
					<th style={{ width: "30px" }}>Action</th>
				</tr>
			</thead>
			<tbody>
				{ 
					searchResults && searchResults.map((item, key) => 
					(<tr key={key}>
						<td>{key + 1}{' .'} {item.season}</td>
						<td>{item.name}</td>
						<td>{item.directorName}</td>
						<td>{moment(item.startDate).format('LL')}</td>
						<td>{moment(item.endDate).format("LL")}</td>
						<td>{item.status}</td>
						<td>
								<Button style={{ color:blue }} onClick={() => this.handleViewEventDetails(item.eventId)}>
									<i className="fa fa-arrow-right" aria-hidden="true"  />&nbsp;Manage
								</Button>
							</td>
					</tr>))
				}
			</tbody>
		</Table>
    </Col>
	</Row>
	</ContentWrapper>)
 }
}
SearchResults.propTypes = {
	searchResults: PropTypes.array,
	onViewEventDetails: PropTypes.func
}

const mapStateToProps = ({  oidc, user }) => {
	return {
    oidc: { ...oidc },
    user: { ...user },
	}
}
export default (connect(mapStateToProps,null)(SearchResults));


// WEBPACK FOOTER //
// ./src/containers/postevent/components/searchresults.js